import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditInspectionStation() {
  const [f_t_name, setF_t_name] = useState();
  const [f_t_no, setF_t_no] = useState();
  const [f_t_status, setF_t_status] = useState(0);
  let { id } = useParams();
  const classes = useStyles();

  const EmpId = localStorage.getItem("EmpId");
  const [ModId, setModId] = useState("1");
  //fetch Data

  const data_params = { id: id };
  // console.log(id)
  const getData = async () => {
    try {
      const data = await api
        .post("api/inspectionStation/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              setF_t_name(res.InspectionStationName);
              setModId(res.ModId);
              // res.Status.data.map((res) => {
              //   setF_t_status(res);
              //   console.log(res);
              // });
              setF_t_status(res.Status === true ? 1 : 0)
            });
          } else {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/inspectionStation");
                }
              });
            });
            // console.log("Nodata" + response);
          }
          //   console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // console.log(id);
    // GET request using axios inside useEffect React hook
    getData();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  const history = useHistory();
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ด่านตรวจ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Inspection Station
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Inspection Station
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{ f_t_name: "" }}
          validate={(values) => {
            const errors = {};
            if (!f_t_name || f_t_name === "") {
              errors.f_t_name = "Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                id: id,
                // no: f_t_no,
                name: f_t_name,
                ModId: ModId,
                status: f_t_status,
              };

              api
                .post("api/inspectionStation/update", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "แก้ไขข้อมูลด่านตรวจ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/InspectionStation");
                      }
                    });
                  });
                  console.log(respose);
                })
                .catch((err) => {
                  console.log(err);
                });

              // alert(JSON.stringify(f_t_no + f_t_name + f_t_status, null, 2));
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                แก้ไขด่านตรวจ
              </h6>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={3} md={12}>
                  <TextField
                    name="f_t_name"
                    label="Inspection Station"
                    variant="outlined"
                    placeholder="Inspection Station"
                    style={{ width: "50%" }}
                    onChange={(e) => setF_t_name(e.target.value)}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={f_t_name}
                    classes={{ root: !f_t_name ? classes.customOutline : null }}
                    required
                  />
                  {/* {errors.f_t_name && touched.f_t_name && errors.f_t_name} */}
                </Grid>
                <Grid item xs={6} sm={4} md={10} sx={{ display: "flex" }}>
                  {/* <TextField
                    label="FREIGHT TERMS NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter FREIGHT TERMS NO."
                    name="f_t_no"
                    style={{
                      width: "40%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={(e) => setF_t_no(e.target.value)}
                    onBlur={handleBlur}
                    value={f_t_no}
                  />
                  {errors.f_t_no && touched.f_t_no && errors.f_t_no} */}

                  <FormControl fullWidth>
                    <InputLabel id="select_status-label">Status</InputLabel>
                    <Select
                      name="select_status"
                      id="select_status"
                      value={f_t_status}
                      style={{
                        width: "40%",
                        // marginLeft: "10px",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      label="Status"
                      onChange={(e) => setF_t_status(e.target.value)}
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
